import { apiCatalogs, endpoints } from '@/api'

export type BlockchainCodeType =
  | 'BTC'
  | 'ARB'
  | 'ETH'
  | 'MATIC'
  | 'SOL'
  | 'TRX'
  | string

export interface BlockchainCatalogsDTO {
  id: number
  code: BlockchainCodeType
  name: string
  img_url?: string
  arrival_time?: number
}

export interface BlockchainCatalogsParams {
  currency_isin: string
}

export async function fetchBlockchains({
  currency_isin,
}: BlockchainCatalogsParams): Promise<{
  blockchains: BlockchainCatalogsDTO[]
}> {
  const res = await apiCatalogs.get<{ blockchains: BlockchainCatalogsDTO[] }>(
    endpoints.blockchains.getBlockchains(currency_isin),
  )
  return res.data
}
